angular
    .module('webcomm')
    .controller('ChannelFeedController', [
        '$scope',
        '$log',
        '$timeout',
        'textMessageService',
        'feedModel',
        'endpointModel',
        'userService',
        'pttService',
        'privateCallPttService',
        function ($scope, $log, $timeout, textMessageService, feedModel, endpointModel, userService, pttService, privateCallPttService) {
            var selectedChannel;
            let channelPttService = pttService.create($scope.channel.id);
            let unbindFeedEventCallback;
            let feedTimeout;
            let userPresent = true;

            function init() {
                loadFeedEvents($scope.channel.id);
                //$log.debug("ChannelFeedController initialized");
                //may miss the broadcasting message 'channelModel.channelSelected' before channelFeedController is ready. 
                //so init the textMessaingDisabledOnChannel[$scope.channel.id]
                $scope.textMessagingDisabledOnChannel[$scope.channel.id] = channelPttService.isRxOnlyChannel();
            }

            function setTextMessagingDisabled(val) {
                $scope.textMessagingDisabledOnChannel[selectedChannel.id] = val;
            }

            function loadFeedEvents(channelId) {
                // load the last X events at first, then start loading previous ones incrementally
                let feedEvents = feedModel.getChannelFeed(channelId);

                // grab the last page
                let lastPageStart = Math.max(feedEvents.length - 13, 0);
                let lastPage = feedEvents.slice(lastPageStart);
                $scope.visibleFeedEvents = lastPage;

                if (lastPageStart > 0) {
                    unbindFeedEventCallback = $scope.$on('feedModel.feedEventReceived', (event, feedEvent) => {
                        if (feedEvent.channelId === channelId)
                            $scope.visibleFeedEvents.push(feedEvent);
                    })
                    addAnotherElement(channelId, feedEvents, lastPageStart - 1);
                }
                else {
                    $scope.visibleFeedEvents = feedModel.getChannelFeed(channelId);
                }
            }

            function addAnotherElement(channelId, feedEvents, index) {
                feedTimeout = $timeout(() => {
                    $scope.visibleFeedEvents.splice(0, 0, feedEvents[index])
                    index--;
                    if (index > 0)
                        addAnotherElement(channelId, feedEvents, index);
                    else {
                        $scope.visibleFeedEvents = feedModel.getChannelFeed(channelId);
                        unbindFeedEventCallback();
                    }
                }, 5);
            }

            function isPrivateCallChannel(channelId) {
                return channelId < 0;
            }

            // Scope variables

            $scope.textMessagingDisabledOnChannel = {};
            $scope.channelFeed = { message: '' };
            $scope.messageCounter = 0;

            var unbindChannelSelected = $scope.$on('channelModel.channelSelected', function (event, channel) {
                unbindFeedEventCallback && unbindFeedEventCallback();
                feedTimeout && $timeout.cancel(feedTimeout);

                // release existing resources and re-point ptt service to correct channel
                $log.debug("ChannelFeedController channel changed - ", channel);
                channelPttService.destroy();
                if(channel.id < 0) {
                    channelPttService = privateCallPttService.create(channel.id);
                } else {
                    channelPttService = pttService.create(channel.id);
                }
                selectedChannel = channel;

                loadFeedEvents(channel.id);

                if (channel.id > 0) {
                    setTextMessagingDisabled(channelPttService.isRxOnlyChannel());
                }
            });

            var unbindUsersLoaded = $scope.$on('userService.usersLoaded', () => {
                // If userService.usersLoaded is fired but a channel hasn't been selected yet, then this is the initial load of
                // of endpoints and this controller wasn't loaded yet to capture the channel select
                if (selectedChannel && selectedChannel.id < 0 && !$scope.textMessagingDisabledOnChannel[selectedChannel.id]) {
                    let user = userService.getUser(selectedChannel.participantId);
                    if (selectedChannel.participantId && user && user.privateTextEnabled) {
                        setTextMessagingDisabled(false);
                    } else {
                        setTextMessagingDisabled(true);
                    }
                }
            });

            var unbindSpeakersChangedEvent = $scope.$on('endpointStatusService.speakersChanged', function (event, data) {
                if (data.channelId === $scope.channel.id) {
                    $scope.status.activityMessage = data.speakerCount ? data.message : ""; // only show message if there are speakers
                }
            });

            var unbindUserPrivateTextEnabled = $scope.$on('userService.privateTextEnabled', (e, user, enabled) => {
                if($scope.channel.id < 0 && $scope.channel.participantId === user.userName) {
                    $scope.textMessagingDisabledOnChannel[$scope.channel.id] = !enabled;
                }
            });

            var unbindUserLeft = $scope.$on('userService.userLeft', (e, user, channelId) => {
                if(isPrivateCallChannel(channelId)) {
                    userPresent = false;
                    setTextMessagingDisabled(true);
                }
            });

            var unbindUserJoined = $scope.$on('userService.userJoined', (e, userInfo) => {
                if(userInfo.userName === $scope.channel.participantId && !userPresent) {
                    userPresent = true;
                    setTextMessagingDisabled(false);
                }
            });

            // $scope.eventFeed = function() {
            //     let feed = feedModel.getChannelFeed($scope.channel.id);
            //     //console.error(feed);
            //     return feed;
            //
            // };

            $scope.status = {
                activityMessage: '',
                isActionBarVisible: true,
                isPTTButtonEnabled: function () {
                    return $scope.channel.bargeCall || channelPttService.canTransmitAudio();
                },
                getPttIconName() {
                    return channelPttService.getPttIconName(false);
                },
                isPttOn() {
                    return channelPttService.isPttOn();
                },
                showTextMessageBox() {
                    this.isActionBarVisible = false;
                    $scope.$evalAsync(() => {
                        $scope.$emit('timeForResize');
                    });
                }
            };

            $scope.sendTextMessage = function (message, feedId, isAlert) {

                if( $scope.channel.id < 0 ) {
                    let ep = endpointModel.getMyEndpoint();
                    let targetUser = userService.getUser($scope.channel.participantId);
                    textMessageService.sendPrivateTextMessage($scope.channel, targetUser, ep, message, feedId, isAlert)
                        .then((resp) => {
                            $scope.$broadcast('textMessageSentConfirmed', resp);
                        })
                        .catch((err) => {
                            $scope.$broadcast('textMessageSentError', err.feedId, err.errorMessage);
                        });
                } else {
                    textMessageService.sendTextMessage($scope.channel, endpointModel.getMyEndpoint(), message, feedId, isAlert)
                        .then((resp) => {
                            $scope.$broadcast('textMessageSentConfirmed', resp);
                        })
                        .catch((err) => {
                            $scope.$broadcast('textMessageSentError', err.feedId, err.errorMessage);
                        });
                }
                $scope.clearAndHideMessageBox();
                $scope.messageCounter++;
            };

            $scope.clearAndHideMessageBox = function () {
                $scope.channelFeed.message = '';
                $scope.status.isActionBarVisible = true;
            }


            $scope.pttStart = function ($event) {
                // this is to stop the system from interpreting the PTT click as a channel select
                if ($event) {
                    $event.stopImmediatePropagation();
                }
                if (!channelPttService.isPttOn()) {
                    channelPttService.pttStart();
                }
            };

            $scope.pttStop = function ($event) {
                // this is to stop the system from interpreting the PTT click as a channel select
                if ($event) {
                    $event.stopImmediatePropagation();
                }
                channelPttService.pttStop();
            };

            $scope.openFullscreenMap = function ($event) {
                $event && $event.stopPropagation();
                $scope.$emit('map.openFullscreenMap');
            }

            $scope.$on('$destroy', function () {
                //unbindFeedEventReceived();
                channelPttService && channelPttService.destroy();
                unbindChannelSelected();
                unbindUserPrivateTextEnabled();
                unbindSpeakersChangedEvent();
                unbindUserLeft();
                unbindUserJoined();
                unbindUsersLoaded();
                $log.debug('ChannelFeedController destroyed');
            })();

            init();
        }
    ])